import "core-js/modules/es6.array.map";
import i, { useContext as l } from "react";
import { PrimaryNavContext as v } from "./PrimaryNavContext";
import { MenuItem as y } from "./MenuItem";
import { QuickLinksMenu as _ } from "./QuickLinksMenu";
import { UserActionsLogin as h } from "./UserActionsLogin";
import { UserActionsMenu as f } from "./UserActionsMenu";
import d from "clsx";

var A = function A(_ref) {
  var s = _ref.activeIndex;
  var e;

  var _l = l(v),
      r = _l.menuData,
      o = _l.activeFlyout,
      t = _l.isAnimating,
      a = _l.isBreakpointWithMenu,
      n = _l.authenticatedUser,
      p = _l.isSubmenuOpen;

  return i.createElement("li", {
    className: d("hg-primarynav__item", "hg-primarynav__menu", {
      "hg-primarynav__item--flyout-open": a && !t && !p && o !== null
    })
  }, i.createElement("div", {
    className: "hg-primarynav__flyout",
    "data-topnav-flyout": "menu"
  }, i.createElement("div", {
    className: "hg-primarynav__menu-list",
    style: {
      "--primarynav-flyout-item-total": (e = r == null ? void 0 : r.primaryLinks) == null ? void 0 : e.length
    }
  }, n && i.createElement("div", {
    className: "hg-primarynav__useractions-menu"
  }, i.createElement(f, {
    isMobile: !0
  })), (r == null ? void 0 : r.primaryLinks) && i.createElement(i.Fragment, null, i.createElement("h2", {
    className: "hg-primarynav__menu-header"
  }, "Services"), r.primaryLinks.map(function (m, u) {
    return i.createElement(y, {
      key: m.id,
      item: m,
      isActive: s === u
    });
  })), (r == null ? void 0 : r.quickLinks) && i.createElement(_, null), !n && i.createElement(h, null))));
};

export { A as Menu };